const getStyles = (theme) => ({
  separator: {
    borderLeft: "solid 1px #AFAFAF",
    height: "35px",
  },
});

export default getStyles;
